import React, { useEffect, useState } from 'react'
import { loadingState } from 'src/atom/LoadingState'
import { useRecoilState } from 'recoil'
import { useLocation } from 'react-router-dom'
import { globalStream } from 'src/atom/GlobalStream'
import { useNavigate } from 'react-router-dom'
import { verifyOTP, resendMobileOTP, resendEmailOTP } from 'src/services/Registration/RegisterationService'
import Toastify, { showToast } from 'src/utils/Tostify'
import LogoHeader from 'src/components/header/LogoHeader'

const OtpScreen = () => {
  const [formData, setFormData] = useState(null)
  const [showMobileResendButton, setShowMobileResendButton] = useState(false)
  const [showEmailResendButton, setShowEmailResendButton] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [loader, enableLoader] = useRecoilState(loadingState)
  const [mobileCountdown, setMobileCountdown] = useState(30)
  const [emailCountdown, setEmailCountdown] = useState(30)
  const [GSteam, setGlobalSteam] = useRecoilState(globalStream)
  const navigate = useNavigate()
  const [validationErrors, setValidationErrors] = useState({
    mobileOTP: '',
    emailOTP: '',
  })

  useEffect(() => {
    setFormData({
      mobileOTP: '',
      emailOTP: '',
      rollNo: GSteam.neetRollNumber
    })
  }, [])

  useEffect(() => {
    if (!GSteam.neetRollNumber) {
      navigate('/homepage');
    }
  }, [GSteam.neetRollNumber]);

  const handleResend = async (type) => {
    try {
      enableLoader(true)
      if (type === 'mobile') {
        setMobileCountdown(30)
        setShowMobileResendButton(false)
        await handleResendMobileOTP(formData?.rollNo)
      } else if (type === 'email') {
        setEmailCountdown(30)
        setShowEmailResendButton(false)
        await handleResendEmailOTP(formData?.rollNo)
      }
    } catch (error) {
      showToast(error.message, 'error')
    } finally {
      enableLoader(false)
    }
  }

  const handleResendMobileOTP = async (rollNo) => {
    try {
      const response = await resendMobileOTP(rollNo)
      if (response.success) {
        setFormData((prev) => ({ ...prev, mobileOTP: '' }))
        showToast('Mobile OTP sent successfully', 'success')
      } else {
        showToast('Mobile OTP Failure', 'error')
      }
    } catch (error) {
      showToast(error.message, 'error')
      throw error
    }
  }

  const handleResendEmailOTP = async (rollNo) => {
    try {
      const response = await resendEmailOTP(rollNo)
      if (response.success) {
        setFormData((prev) => ({ ...prev, emailOTP: '' }))
        showToast('Email OTP sent successfully', 'success')
      } else {
        showToast('Email OTP Failure', 'error')
      }
    } catch (error) {
      showToast(error.message, 'error')
      throw error
    }
  }

  const validateForm = () => {
    let errors = {}
    let isValid = true
    if (!formData.mobileOTP) {
      errors.mobileOTP = 'Please provide Mobile OTP'
      isValid = false
    }
    if (!formData.emailOTP) {
      errors.emailOTP = 'Please provide Email OTP'
      isValid = false
    }
    setValidationErrors(errors)
    return isValid
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    enableLoader(true)
    const isValid = validateForm()
    if (isValid) {
      setIsSubmitting(true)
      const response = await verifyOTP(formData)
      if (response.success) {
        const det = response.body
        enableLoader(false)
        setIsSubmitting(false)
        navigate('/registration-validation-details', { state: { det } })
      } else {
        setIsSubmitting(false)
        enableLoader(false)
        showToast(response?.message, 'error')
      }
    } else {
      enableLoader(false)
    }
  }

  useEffect(() => {
    let mobileTimer = null
    let emailTimer = null

    if (mobileCountdown > 0) {
      mobileTimer = setTimeout(() => {
        setMobileCountdown(mobileCountdown - 1)
      }, 1000)
    } else {
      setShowMobileResendButton(true)
    }

    if (emailCountdown > 0) {
      emailTimer = setTimeout(() => {
        setEmailCountdown(emailCountdown - 1)
      }, 1000)
    } else {
      setShowEmailResendButton(true)
    }

    return () => {
      clearTimeout(mobileTimer)
      clearTimeout(emailTimer)
    }
  }, [mobileCountdown, emailCountdown])

  const handleOTPChange = (e) => {
    const { name, value } = e.target
    if (/^[0-9]{0,6}$/.test(value) || value === '') {
      setFormData({
        ...formData,
        [name]: value === '' ? '' : parseInt(value),
      })
      setValidationErrors({
        ...validationErrors,
        [name]: ''
      })
    }
  }

  return (
    <>
      <div className="card">
        <LogoHeader />
      </div>
      <div
        className="mt-2 d-flex justify-content-center align-items-center"
        style={{ fontWeight: 'bold', fontSize: '25px' }}
      >
        Online Application Form For Admission To {GSteam.counsellingName === 'UG' ? 'BAMS/BHMS ' : 'MD/MS (Ayurveda) '}
        {' '} Courses 2026-27
      </div>

      <div className="card ms-5 me-5 mt-3">
        <div className="card-body">
          <div className="row">
            <div className="col-12 d-flex justify-content-start">
              <th>Instruction Details</th>
            </div>
          </div>
          <hr />
          <div className="row mt-2">
            <div className="col-sm-12">
              <div className="d-flex flex-column align-items-left">
                <label style={{ color: 'red' }}>
                  <div>1. OTP has been generated.</div>
                  <div>
                    2. User Id and Password will be sent to your registered email ID and mobile number.
                  </div>
                </label>
              </div>
              <div className="row justify-content-center">
                <div className="row justify-content-center">
                  <div className="col-4 d-flex justify-content-center align-items-center">
                    <div className="col-12 mt-3 text-center">
                      <label htmlFor="mobileOTP">Mobile OTP:</label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          className={`form-control ${validationErrors.mobileOTP ? 'is-invalid' : ''}`}
                          id="mobileOTP"
                          name="mobileOTP"
                          placeholder="Enter Mobile OTP"
                          value={formData?.mobileOTP}
                          onChange={handleOTPChange}
                        />
                        {showMobileResendButton && (
                          <button
                            className="ms-2 btn btn-sm btn-danger text-white"
                            type="button"
                            onClick={() => handleResend('mobile')}
                            disabled={isSubmitting}
                          >
                            Resend
                          </button>
                        )}
                      </div>
                      {validationErrors.mobileOTP && (
                        <div className="invalid-feedback">{validationErrors.mobileOTP}</div>
                      )}
                      {mobileCountdown > 0 && (
                        <div className="mt-2 text-center">
                          <b><p>Resend Mobile OTP After: {mobileCountdown} seconds</p></b>
                        </div>
                      )}
                      <label htmlFor="emailOTP" className="mt-3">Email OTP:</label>
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          className={`form-control ${validationErrors.emailOTP ? 'is-invalid' : ''}`}
                          id="emailOTP"
                          name="emailOTP"
                          placeholder="Enter Email OTP"
                          value={formData?.emailOTP}
                          onChange={handleOTPChange}
                        />
                        {showEmailResendButton && (
                          <button
                            className="ms-2 btn btn-sm btn-danger text-white"
                            type="button"
                            onClick={() => handleResend('email')}
                            disabled={isSubmitting}
                          >
                            Resend
                          </button>
                        )}
                      </div>
                      {validationErrors.emailOTP && (
                        <div className="invalid-feedback">{validationErrors.emailOTP}</div>
                      )}
                      {emailCountdown > 0 && (
                        <div className="mt-2 text-center">
                          <b><p>Resend Email OTP After: {emailCountdown} seconds</p></b>
                        </div>
                      )}
                      <div className="mt-2">
                        <button
                          type="submit"
                          className="mt-2 btn btn-sm btn-success text-white"
                          onClick={handleSubmit}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toastify />
    </>
  )
}

export default OtpScreen